import classNames from "classnames";
import "./style.scss";

interface Props {
  className?: string;
  data: {
    value: string;
    label: string;
    count?: string;
  }[];
  value: string;
  onChange?(active: string): void;
  size?: "small" | "medium" | "large";
  onBadgeClick?: (tab: string) => void;
}

export const TabBar = ({
  className,
  data,
  value,
  onChange = () => {},
  size = "medium",
  onBadgeClick = () => {},
}: Props) => {
  return (
    <div className={classNames("tab-bar", size, className)}>
      {data.map((item) => (
        <div
          className={classNames("tab-bar__cell", size, {
            active: item.value === value,
            half: data.length === 2,
          })}
          onClick={() => onChange(item.value)}
          key={item.label}
        >
          {item.count && (
            <span
              className="tab-bar__cell-badge"
              onClick={(e) => {
                e.stopPropagation();
                onBadgeClick(item.value);
              }}
            >
              {item.count}
            </span>
          )}
          <div className="tab-bar__cell-text">{item.label}</div>
        </div>
      ))}
    </div>
  );
};
